// 权限检查工具
export const checkEditPermission = () => {
  const hasEditAllPermission = localStorage.getItem('hasEditAllPermission') === 'true';
  return hasEditAllPermission;
};

// 检查是否可以编辑特定表单
export const canEditForm = (formOwnerId, currentUserId) => {
  const hasEditAllPermission = checkEditPermission();
  
  // 如果有全部编辑权限，可以编辑任何表单
  if (hasEditAllPermission) {
    return true;
  }
  
  // 否则只能编辑自己的表单
  return formOwnerId === currentUserId;
};

// 获取权限状态文本
export const getPermissionStatus = () => {
  const hasEditAllPermission = checkEditPermission();
  return hasEditAllPermission ? '全部编辑权限' : '仅自己表单编辑权限';
};

// 权限相关的常量
export const PERMISSION_TYPES = {
  EDIT_ALL: 'edit_all',
  EDIT_OWN: 'edit_own'
};

export default {
  checkEditPermission,
  canEditForm,
  getPermissionStatus,
  PERMISSION_TYPES
};
